import { render, staticRenderFns } from "./LibraryContentHeader.vue?vue&type=template&id=84febcea&scoped=true&"
import script from "./LibraryContentHeader.vue?vue&type=script&lang=js&"
export * from "./LibraryContentHeader.vue?vue&type=script&lang=js&"
import style0 from "./LibraryContentHeader.vue?vue&type=style&index=0&id=84febcea&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84febcea",
  null
  
)

export default component.exports